module.exports = __webpack_public_path__ + "img/znx-logo.fb81aa4b.png";